export const SUPER_USER = "SUPER_USER"
export const BU_USER = "BU_USER"
export const READ_ONLY_USER = "READ_ONLY"
export const USER = "USER"
